import { storage } from '../firebase'
import { ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage'
import { v4 as uuidv4 } from 'uuid'
import { getPublicStorageUrl } from '.'
export const uploadLogo = async (file: File, onProgress?: (progress: number) => void): Promise<string> => {
  try {
    // Generate a unique filename
    const storedFileName = `${uuidv4()}.${file.name.split('.').pop()}`
    const storageRef = ref(storage, `competitors/logos/${storedFileName}`)

    // Upload the file
    const uploadTask = uploadBytesResumable(storageRef, file)

    // Return a promise that resolves with the download URL
    return new Promise((resolve, reject) => {
      uploadTask.on(
        'state_changed',
        (snapshot) => {
          // Calculate progress
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          // Call the progress callback if provided
          if (onProgress) {
            onProgress(progress)
          }
        },
        (error) => {
          console.error('Error uploading logo:', error)
          reject(error)
        },
        () => {
          // Get the download URL
          const downloadURL = getPublicStorageUrl('competitors%2Flogos', storedFileName)
          resolve(downloadURL)
        }
      )
    })
  } catch (error) {
    console.error('Error in uploadLogo:', error)
    throw error
  }
}
